














































import { DateTime, Interval } from 'luxon'
import { ScheduleProgram } from '@/models/program'
import { Schedule, schedule } from '@/services/program-service'
import { Component, Vue } from 'vue-property-decorator'
import PochetteSection from './PochetteSection.vue'
import { ScheduleSong } from '@/models/song'
import ScheduleSongComponent from './ScheduleSong.vue'

@Component({
  components: { PochetteSection, ScheduleSongComponent }
})
export default class ProgramSection extends Vue {
  schedule: Schedule | null = null

  get previousSongs (): ScheduleSong[] {
    if (!this.schedule) return []
    return this.schedule.songs
      .slice(1, 3)
  }

  mounted () {
    this.reloadSchedule().then()
  }

  formatNow (): string {
    return DateTime.now().setLocale('fr').toFormat('EEEE dd MMMM - HH:mm')
  }

  formatProgramDate (program: ScheduleProgram): string {
    const start = DateTime.fromMillis(program.start).toFormat('HH:mm')
    const end = DateTime.fromMillis(program.end).toFormat('HH:mm')
    return `${start} - ${end}`
  }

  formatDate (date: number): string {
    return DateTime.fromMillis(date).toFormat('HH:mm')
  }

  formatDuration (program: ScheduleProgram): string {
    const duration = Interval.fromDateTimes(new Date(program.start), new Date(program.end)).toDuration(['hours', 'minutes', 'seconds'])
    if (duration.hours >= 1 && duration.minutes > 0) return duration.toFormat('h\'h\'mm')
    if (duration.hours > 1) return duration.toFormat('h \'heures\'')
    if (duration.hours === 1) return duration.toFormat('h \'heure\'')
    if (duration.minutes >= 1 && duration.seconds > 0) return duration.toFormat('m\'m\'ss')
    if (duration.minutes > 1) return duration.toFormat('m \'minutes\'')
    if (duration.minutes === 1) return duration.toFormat('m \'minutes\'')
    return duration.toFormat('s \'secondes\'')
  }

  private async reloadSchedule () {
    this.schedule = await schedule()
  }
}
